var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-dialog',{attrs:{"dialogState":_vm.confirmDialogueVar,"dialogTitle":_vm.dialogTitle,"dialogText":_vm.dialogText,"confirmDialog":true,"actions":{
    show: true,
    secondaryButtonFunction: function () { return this$1.$emit('cancelSaveSetting'); },
    primaryButtonFunction: _vm.saveVirusSetting,
    primaryButtonShow: true,
    secondaryButtonText: _vm.cancelText,
    primaryButtonText: _vm.successText,
  }},on:{"toggleModal":function () { return this$1.$emit('cancelSaveSetting'); }}})}
var staticRenderFns = []

export { render, staticRenderFns }